import { render, staticRenderFns } from "./GroupCommentList.vue?vue&type=template&id=59aa9f09"
import script from "./GroupCommentList.vue?vue&type=script&lang=js"
export * from "./GroupCommentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports